<div>
  <div
    class="border-b-ui-gray-light border-b flex items-center mb-3"
    [class]="buildingDataFilterService.showTabs ? 'justify-between' : 'justify-end'"
  >
    @if (buildingDataFilterService.showTabs) {
      <mat-button-toggle-group
        class="desktop-toggle-group"
        (change)="buildingDataFilterService.buildingStatusFilter = $event.value"
        [value]="buildingDataFilterService.buildingStatusFilter"
        aria-label="Building Status"
        name="site-status"
      >
        <mat-button-toggle
          class="test-building-status-open"
          value="current"
        >
          <span class="item-status-title">Current</span>
        </mat-button-toggle>
        <mat-button-toggle
          class="test-building-status-history"
          value="archived"
        >
          <span class="item-status-title">Archived</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }

    <div class="flex items-center h-16">
      <app-search-input
        (searchDataEvent)="buildingDataFilterService.search = $event"
        placeholder="Building name"
      />
    </div>
  </div>

  @if (buildingDataFilterService.buildingStatusFilter !== 'archived') {
    <div class="flex items-start flex-wrap test-filters-panel">
      <mat-form-field
        class="test-status-filter stroked-select-single mr-2 mb-3"
        appearance="outline"
      >
        <mat-select-trigger>Status</mat-select-trigger>
        <mat-select
          (valueChange)="buildingDataFilterService.statusFilter = $event"
          [value]="buildingDataFilterService.statusFilter"
          panelClass="single-select-overlay"
        >
          @for (siteStatus of buildingDataFilterService.siteStatusOptions | sort : 'asc' : 'title' : 'all'; track siteStatus) {
            <mat-option [value]="siteStatus.value">
              {{ siteStatus.title }}
            </mat-option>
          }
        </mat-select>
        <mat-icon
          class="arrow-down"
          matSuffix
        >keyboard_arrow_down</mat-icon>
      </mat-form-field>
      <app-multiple-select
        class="mr-2 test-incident-status-select-filter"
        (selectDataEvent)="buildingDataFilterService.incidentFilter = $event"
        [options]="buildingDataFilterService.incidentOptions"
        [value]="buildingDataFilterService.incidentFilter"
        label="Incidents"
        panelClass="multiselect-alert-overlay"
        selectClass="stroked-select-multiple mb-3"
      />
      @if (selectedFilters) {
        <button
          class="text-sm text-ui-dark font-normal underline h-9 ml-3 test-clear-all-filters"
          (click)="clearAllFilters()"
          mat-button
        >
          Clear All
        </button>
      }
    </div>
  }
</div>
